<template>
  <div>
    <div class="mb-3">
      <div class="d-inline">
        <date-picker :editable="false"
                     :format="momentFormat"
                     clearButton="false"
                     input-class="form-control form-control-sm"
                     lang="ru"
                     :first-day-of-week="1"
                     placeholder="С"
                     style="width: auto;"
                     v-model="from"
                     valueType="format">
        </date-picker>
      </div>
      <div class="d-inline ml-md-3">
        <date-picker :editable="false"
                     :format="momentFormat"
                     clearButton="false"
                     input-class="form-control form-control-sm"
                     lang="ru"
                     :first-day-of-week="1"
                     placeholder="По"
                     style="width: auto;"
                     v-model="to"
                     valueType="format">
        </date-picker>
      </div>
      <div class="d-inline ml-md-3">
        <label class="form-check-label" for="unPaid">
          <input id="unPaid" type="checkbox" v-model="unPaid"> Только не оплаченные
        </label>
      </div>
      <div class="d-inline ml-md-3">
        <label class="form-check-label" for="unPassed">
          <input id="unPassed" type="checkbox" v-model="unPassed"> Только не сданные
        </label>
      </div>
      <div class="d-inline ml-md-3">
        <label class="form-check-label" for="justBN">
          <input id="justBN" type="checkbox" v-model="justBN"> Только БН
        </label>
      </div>
      <div class="d-inline ml-md-3">
        <button @click.prevent="print" class="btn btn-sm btn-secondary">Печать</button>
      </div>
    </div>
    <div id="customer-orders">
      <table class="table table-sm table-bordered table-hover mb-3 w-100">
        <thead>
        <tr>
          <th>Номер сферы</th>
          <th width="300">Номер клиента</th>
          <th width="1000">Название</th>
          <th width="200">Дата клиента</th>
          <th width="200">Дата создания</th>
          <th width="200">Дата отправки</th>
          <th width="200">Дата оплаты</th>
          <th width="200">Тип оплаты</th>
          <th width="200">Цена</th>
        </tr>
        </thead>
        <tbody>
        <tr :key="order.Id" v-for="order in orders">
          <td class="text-nowrap">
            <router-link :to="{ name: 'order-info', params: {orderId: order.Id}}"
                         class="text-decoration-none"
                         target="_blank">
              {{order.RecastNumber > 0 ? 'Переделка заказа ' : ''}}
              {{order.SferaNumber}}
            </router-link>
          </td>
          <td class="overflow-hidden text-nowrap" style="max-width: 0; text-overflow: ellipsis;">{{order.LocalNumber}}</td>
          <td class="overflow-hidden text-nowrap" style="max-width: 0; text-overflow: ellipsis;">
            {{order.Name}}
          </td>
          <td class="">{{order.CustomerDate | formatDate("DD/MM/YYYY")}}</td>
          <td class="">{{order.ReceivedDate | formatDate("DD/MM/YYYY")}}</td>
          <td class="">{{order.DispatchDate | formatDate("DD/MM/YYYY")}}</td>
          <td class="">{{order.PaidDate | formatDate("DD/MM/YYYY")}}</td>
          <td class="">{{getPaymentTypeById(order.PaymentTypeId).Name}}</td>
          <td class="">{{order.Summary}}</td>
        </tr>
        </tbody>
      </table>
    </div>

  </div>


</template>

<script>
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import { get } from '@/admin/services/api/http-utils';

const queryString = require('query-string');

const date = new Date();
const to = moment(date)
  .format('DD-MM-YYYY');
date.setDate(date.getDate() - 7);
const from = moment(date)
  .format('DD-MM-YYYY');
// const from = '01-01-2019';

export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      orders: [],
      from,
      to,
      unPaid: false,
      unPassed: false,
      justBN: false,
      momentFormat: {
        // Date to String
        stringify: date => (date ? moment(date)
          .format('DD-MM-YYYY') : ''),
        // String to Date
        parse: value => (value ? moment(value, 'DD-MM-YYYY')
          .toDate() : null),
      },
      printObj: {
        id: '#customer-orders',
        popTitle: 'good print',
        extraCss: 'https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/js/bootstrap.min.js',
        extraHead: '<meta http-equiv="Content-Language"/>',
      },
    };
  },
  filters: {
    formatDate(value, format) {
      if (value) {
        return moment(value, 'DD-MM-YYYY')
          .format(format);
      }
      return '';
    },
  },
  watch: {
    from() {
      this.fetchOrders();
    },
    to() {
      this.fetchOrders();
    },
    unPaid() {
      this.fetchOrders();
    },
    unPassed() {
      this.fetchOrders();
    },
    justBN() {
      this.fetchOrders();
    },
  },
  mounted() {
    // const date = new Date();
    // this.to = moment(date)
    //   .format('DD-MM-YYYY');
    // date.setDate(date.getDate() - 7);
    // this.from = moment(date)
    //   .format('DD-MM-YYYY');
    this.fetchOrders();
  },
  methods: {
    async fetchOrders() {
      console.log('fetchOrders');
      if (!this.from || !this.to) return;
      console.log('fetchOrders true');
      const query = queryString.stringify({ unPaid: this.unPaid, unPassed: this.unPassed, justBN: this.justBN });
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/customer/${this.$route.params.id}/orders/${this.from}/${this.to}?${query}`);
      this.orders = data;
      console.log(this.orders);
    },
    print() {
      this.$htmlToPaper('customer-orders');
    },
    getPaymentTypeById(id) {
      return _.find(this.$root.paymentTypes, pt => pt.Id === id);
    },
  },
};
</script>
